/* eslint-disable import/prefer-default-export */

/*
 * Tracks a custom event with Google Analytics.
 */
export function track(category, action, label = "", value = 1, nonInteraction = true) {
  const options = { nonInteraction, transport: "beacon" };
  ga("send", "event", category, action, label, value, options);
}
